var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[(_vm.loading)?_c('loader'):_c('sales-pivot',{attrs:{"defaultSort":"totalCount","dataObject":_vm.stats,"fields":_vm.fields,"nestedFields":_vm.nestedFields,"equalCols":true,"valueFunctions":_vm.valueFunctions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }